export default __webpack_public_path__ + "static/media/analytics-blue.521def82.svg";